import { render, staticRenderFns } from "./ChangeWarning.vue?vue&type=template&id=79620de6"
import script from "./ChangeWarning.vue?vue&type=script&lang=js"
export * from "./ChangeWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports